import {
  SHELL_BASE_WIDTH_REM,
  CREATOR_PAGE_WIDTH_DEFAULT,
} from "../features/creator-pages/creatorPageWidth";

export const EMBED_WIDTH_MIN = 60;
export const EMBED_WIDTH_DEFAULT = 60;
export const EMBED_WIDTH_MAX = 90;

const REM_PX = 16;

export function coerceEmbedWidthPercent(value: unknown): number {
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n)) return EMBED_WIDTH_DEFAULT;
  return Math.min(
    EMBED_WIDTH_MAX,
    Math.max(EMBED_WIDTH_MIN, Math.round(n))
  );
}

/** 60% → 45rem; 75% → 56.25rem; 90% → 67.5rem (linear from default). */
export function embedWidthPercentToRem(pct: number): number {
  const p = coerceEmbedWidthPercent(pct);
  return (SHELL_BASE_WIDTH_REM * p) / CREATOR_PAGE_WIDTH_DEFAULT;
}

export function getEmbedMaxWidthCss(pct: number): string {
  return `min(90%, ${embedWidthPercentToRem(pct)}rem)`;
}

export function getEmbedShellMaxPx(
  screenWidth: number,
  maxWidthPercent: number
): number {
  const remCap = embedWidthPercentToRem(maxWidthPercent) * REM_PX;
  return Math.min(screenWidth, remCap);
}

export function getEmbedContentWidthPx(
  screenWidth: number,
  maxWidthPercent: number
): number {
  const shell = getEmbedShellMaxPx(screenWidth, maxWidthPercent);
  const horizontalPadding = screenWidth < 890 ? 0 : 60;
  return Math.max(0, shell - horizontalPadding);
}

export function isEmbedNarrowWidth(maxWidthPercent: number): boolean {
  return coerceEmbedWidthPercent(maxWidthPercent) <= EMBED_WIDTH_DEFAULT;
}
